/**
 * Created by tomers on 6/17/2017.
 */
define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var template = require("templates/top-level-menu/topLevelMenuCustomReasonList.tmpl");
    var TopLevelMenuCustomReasonItemView = require("views/top-level-menu/TopLevelMenuCustomReasonItemView");

    var TopLevelMenuCustomReasonListView = Marionette.CollectionView.extend({
        className: "top-level-menu-custom-reasons-list scroll-fixed browser-scroll",
        template: template,
        itemView: TopLevelMenuCustomReasonItemView,

        initialize: function(options) {
            this.container = options.container;
            this.statusModel = options.statusModel;
            this.collection = this.statusModel.getCustomReasons();
            this.selectedReason = this.statusModel.getSelectedReason();
            this._updateSelected();

            this.listenTo(this, "itemview:click", this._onCustomReasonItemClicked);
        },

        itemViewOptions: function() {
            return {
                iconClassName: this.statusModel.getIconClass()
            };
        },

        onRender: function() {
            this.container.append(this.$el);
        },

        _updateSelected: function() {
            this.collection.each(_.bind(function(model){
                model.set("selected", this.selectedReason === model.id);
            }, this));
        },

        _onCustomReasonItemClicked: function(childView) {
            this.selectedReason = childView.model.id;
            this._updateSelected();

            this.trigger("item:click", childView);
        }
    });

    return TopLevelMenuCustomReasonListView;
});
